<p-paginator [rows]="rows"
             [totalRecords]="totalRecords"
             [rowsPerPageOptions]="rowsPerPageOptions"
             (onPageChange)="_paginar($event)">
</p-paginator>
<small *ngIf="totalRecords > 0" class="d-flex justify-content-end me-1">
  <b>{{ 'LABEL_TOTALDE' | translate }} {{ totalRecords >= 10000 ? totalRecords + ' >' : totalRecords }} {{ 'LABEL_REGISTROS' | translate }}</b>
</small>
